import React from 'react';
import { Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import { useVolcanoIcon } from 'hooks/useVolcanoLevels';

export const VolcanosMarker = ({ volcano, onSelect }) => {

   const volcanoMarker = useVolcanoIcon(volcano.properties.activityLevel);

  const markerIcon = L.icon({
    iconUrl: volcanoMarker,
    className: 'leafletDivIcon'
  });

  return (
    <Marker
      position = {[
        volcano.geometry.coordinates[0],
        volcano.geometry.coordinates[1]
      ]}
      icon = { markerIcon }
      eventHandlers={{ click: () => onSelect( volcano ) }}
    >
      <Popup />
    </Marker>
  )
}
